import React from 'react';
import {
  calculateLifeSpanDifference,
  formatDate,
  formatNumber,
} from '../../utils/Helper';
import ImageLoader from '../common/ImageLoader';
import {
  IconLocationSvgIcon,
  RepaidListingSvgIcon,
  SoldOutListingDutchSvgIcon,
  SoldOutListingSvgIcon,
} from '../common/IconProvider';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const ProjectCard = (props) => {
  const location = useLocation();
  let urlSlug = location.pathname.includes('dashboard');
  const language = useSelector((state) => state.languageReducer.language);
  const { t } = useTranslation(['projectCard', 'dashboard', 'common']);
  return (
    props.projectLists &&
    props.projectLists.length > 0 &&
    props.projectLists.map((project, index) => {
      let projectId =
        props.slug === 'owned-assets'
          ? project?.projectDetail?.id
          : project?.id;

      return (
        <Link
          key={index}
          to={
            urlSlug || props.slug !== 'owned-assets'
              ? `/assets/details/${projectId}`
              : `details/${projectId}`
          }
        >
          <div className="bg-[#0B243F] text-white rounded-2xl overflow-hidden text-left h-full">
            <div className="h-44 relative">
              <ImageLoader
                src={
                  props.slug !== 'assets'
                    ? project?.projectDetail?.project_image
                    : project?.project_image
                      ? project?.project_image
                      : '/img/project_image.png'
                }
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = '/img/project_image.png';
                }}
                alt="project"
                className="object-cover w-full h-full"
              />
              <div className="bg-[#0B243F] w-10 h-10 flex justify-center items-center rounded-lg absolute left-3 top-3">
                <ImageLoader
                  src={
                    props.slug === 'owned-assets'
                      ? project?.projectDetail?.projectsType?.icon_url
                      : project?.projectsType?.icon_url
                  }
                  alt=""
                  className={
                    project?.projectsType?.slug === 'wind' ||
                    project?.projectsType?.slug === 'electric'
                      ? 'dark-patch-icon'
                      : ''
                  }
                />
              </div>

              <div className="absolute flex top-2 right-4">
                {project.investment_type === 'bond' &&
                  props.slug === 'assets' && (
                    <div className="rounded-lg text-sm leading-none font-semibold py-2 px-3 bg-yellow-500 text-brandBlue">
                      {t('common:bond')}
                    </div>
                  )}
                {project.investment_type === 'asset' &&
                  props.slug === 'assets' && (
                    <div className="rounded-lg text-sm leading-none font-semibold py-2 px-3 bg-white text-brandBlue ">
                      {t('common:equity')}
                    </div>
                  )}
                {props.slug !== 'assets' && (
                  <div
                    className={`rounded-lg text-sm leading-none font-semibold py-2 px-3 ${
                      project?.projectDetail?.investment_type === 'bond'
                        ? ' bg-yellow-500 text-brandBlue'
                        : ' bg-white text-brandBlue'
                    }`}
                  >
                    {project?.projectDetail?.investment_type === 'bond'
                      ? t('common:bond')
                      : t('common:equity')}
                  </div>
                )}
              </div>
              {props.slug === 'assets' &&
              project?.investment_type === 'bond' &&
              project?.is_repaid === 1 ? (
                <RepaidListingSvgIcon language={language} />
              ) : props.slug === 'owned-assets' &&
                project?.projectDetail?.investment_type === 'bond' &&
                project?.is_repaid === 1 ? (
                <RepaidListingSvgIcon language={language} />
              ) : (
                ''
              )}
              {project.available_for_sale -
                (Number(project?.sold_quantity) +
                  Number(project?.lock_qty_total)) ===
                0 &&
                project?.is_repaid === 0 &&
                (language === 'en' ? (
                  <SoldOutListingSvgIcon />
                ) : (
                  <SoldOutListingDutchSvgIcon />
                ))}
            </div>
            <div className="p-4">
              <h4 className="mb-3 truncate capitalize">
                {' '}
                {props.slug !== 'assets'
                  ? project?.projectDetail?.name
                  : project?.name || 'NA'}
              </h4>
              <div className="mb-4 text-[#85919F] flex items-center">
                <span className="inline-block mr-1 w-4 h-4 min-w-[16px]">
                  <IconLocationSvgIcon />
                </span>
                <span className="textonline">
                  {props.slug === 'assets'
                    ? project?.location
                    : project?.projectDetail?.location || 'NA'}
                </span>
              </div>
              {props.slug === 'assets' && (
                <>
                  {project.price === 0 ? (
                    <div>
                      <div className="bg-[#3D4CB2] rounded-md py-1 px-3 text-sm font-normal inline-block mb-5">
                        {' '}
                        {formatNumber(project?.nominal_value)}{' '}
                      </div>
                    </div>
                  ) : (
                    <div className="flex items-center justify-between mb-5">
                      <div className="bg-[#3D4CB2] rounded-md py-1 px-3 text-sm font-normal inline-block">
                        {' '}
                        {formatNumber(project?.price)}{' '}
                      </div>
                      {Number(project?.available_qty) === 0 ? (
                        ''
                      ) : (
                        <div className="flex justify-between items-center gap-2 text-xs">
                          <div className="font-medium">
                            {Math.max(Number(project?.available_qty || 0), 0)}/
                            <span className="text-[#85919F] font-semibold">
                              {Math.max(Number(project?.total_minted || 0), 0)}
                            </span>
                          </div>
                          <div className="">{t('available')}</div>
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}

              {props.slug !== 'assets' && (
                <>
                  {project?.projectDetail?.price === 0 ? (
                    <div>
                      <div className="bg-[#3D4CB2] rounded-md py-1 px-3 text-sm font-normal inline-block mb-5">
                        {' '}
                        {formatNumber(
                          project?.projectDetail?.nominal_value,
                        )}{' '}
                      </div>
                    </div>
                  ) : (
                    <div className="flex items-center justify-between mb-5">
                      <div className="bg-[#3D4CB2] rounded-md py-1 px-3 text-sm font-normal inline-block">
                        {formatNumber(project?.invested_amount)}
                      </div>
                      {Number(project?.available_qty) === 0 ? (
                        ''
                      ) : (
                        <div className="flex justify-between items-center gap-2 text-xs">
                          <div className="font-medium">
                            {Number(project?.available_qty) || '0'}/
                            <span className="text-[#85919F] font-semibold">
                              {project?.projectDetail?.total_minted || '00'}
                            </span>
                          </div>
                          <div className="">{t('available')}</div>
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}

              {props.slug === 'assets' && (
                <>
                  <div className="flex justify-between items-center mb-1">
                    <div className="">{t('common:total_offering')}</div>
                    <div className="font-medium">
                      {formatNumber(
                        project?.total_minted * project?.nominal_value,
                      )}{' '}
                    </div>
                  </div>

                  <div className="flex justify-between items-center mb-1">
                    <div className="">{t('common:nominal_value')}</div>
                    <div className="font-medium">
                      {formatNumber(project?.nominal_value)}{' '}
                    </div>
                  </div>

                  {project.investment_type === 'bond' ? (
                    <>
                      <div className="flex justify-between items-center mb-1">
                        <div className="">{t('common:annual_yield')}</div>
                        <div className="font-medium">
                          {formatNumber(project?.expected_apy, {
                            style: 'decimal',
                            decimalPlaces: 2,
                          }) || '0'}
                          %
                        </div>
                      </div>
                      <div className="flex justify-between items-center mb-1">
                        <div className="">{t('type')}</div>
                        <div className="font-medium">{t('common:bullet')}</div>
                      </div>
                      <div className="flex justify-between items-center mb-1">
                        <div className="">{t('common:maturity_date')}</div>
                        <div className="font-medium">
                          {formatDate(project?.maturity_date)}
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="flex justify-between items-center mb-1">
                        <div className="">{t('expected_return')}</div>
                        <div className="font-medium">
                          {formatNumber(
                            Math.round(project?.expected_apy * 100) / 100,
                            { style: 'decimal', decimalPlaces: 2 },
                          ) || 'NA'}
                          %
                        </div>
                      </div>
                      <div className="flex justify-between items-center mb-1">
                        <div className="">{t('capacity')}</div>
                        <div className="font-medium">
                          {project?.energy_capacity || 'NA'}
                          MW
                        </div>
                      </div>
                      <div className="flex justify-between items-center mb-1">
                        <div className="">{t('common:remaining_lifetime')}</div>
                        <div className="font-medium">
                          {calculateLifeSpanDifference(project?.life_span_to)}{' '}
                          {t('common:years_left')}
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}

              {props.slug === 'owned-assets' && (
                <>
                  <div className="flex justify-between items-center mb-1">
                    <div className="">{t('dashboard:amount_owned')}</div>
                    <div className="font-medium">
                      {project?.total_quantity || '0'}
                    </div>
                  </div>

                  <div className="flex justify-between items-center mb-1">
                    <div className="">{t('common:invested')}</div>
                    <div className="font-medium">
                      {formatNumber(project?.total_invested_amount) || 'NA'}
                    </div>
                  </div>
                  {project?.projectDetail?.investment_type === 'bond' ? (
                    <>
                      <div className="flex justify-between items-center mb-1">
                        <div className="">{t('common:annual_yield')}</div>
                        <div className="font-medium">
                          {project?.projectDetail?.expected_apy || '0'}%
                        </div>
                      </div>
                      <div className="flex justify-between items-center mb-1">
                        <div className="">{t('common:type')}</div>
                        <div className="font-medium">{t('common:bullet')}</div>
                      </div>
                      <div className="flex justify-between items-center mb-1">
                        <div className="">{t('common:maturity_date')}</div>
                        <div className="font-medium">
                          {formatDate(
                            project?.projectDetail.maturity_date,
                          )}{' '}
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="flex justify-between items-center mb-1">
                        <div className="">{t('common:watt_peak')}</div>
                        <div className="font-medium">
                          {' '}
                          {(
                            (project?.projectDetail?.energy_capacity /
                              project?.projectDetail?.available_for_sale) *
                            project?.quantity
                          ).toFixed(5) || 'NA'}{' '}
                          kW
                        </div>
                      </div>
                      <div className="flex justify-between items-center mb-1">
                        <div className="">{t('dashboard:expected_return')}</div>
                        <div className="font-medium">
                          {formatNumber(
                            Math.round(
                              project?.projectDetail?.expected_apy * 100,
                            ) / 100,
                            { style: 'decimal' },
                          ) || 'NA'}{' '}
                          %
                        </div>
                      </div>
                      <div className="flex justify-between items-center mb-1">
                        <div className="">{t('common:remaining_lifetime')}</div>
                        <div className="font-medium">
                          {calculateLifeSpanDifference(
                            project?.projectDetail?.life_span_to,
                          )}{' '}
                          {t('common:years_left')}
                        </div>
                      </div>
                    </>
                  )}
                  {props.slug === 'owned-assets' && urlSlug && (
                    <button className="bg-[#A7D760] w-full text-[#0B243F] text-lg font-semibold rounded-md px-5 leading-normal py-3 flex flex-col justify-center items-center hover:bg-[#97C05B] focus:bg-[#A7D760] active:bg-[#8DB158] hover:transition-all mt-5">
                      {t('projectDetails:view_project_details')}
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
        </Link>
      );
    })
  );
};

export default ProjectCard;
